/*
 *
 * ShelvesRibbon constants
 *
 */

enum ActionTypes {
  SHELVES_SELECTION_MENU = 'app/ShelvesRibbon/SHELVES_SELECTION_MENU',
  UPDATE_PROFILE_SELECTION = 'app/ShelvesRibbon/UPDATE_PROFILE_SELECTION',
  RESET_SELECTION = 'app/ShelvesRibbon/RESET_SELECTION',
  SELECT_ALL_PIECES = 'app/ShelvesRibbon/SELECT_ALL_PIECES',
  SELECT_ALL_DOORS = 'app/ShelvesRibbon/ALL_DOORS_SELECTION',
  SELECT_ALL_SIDES = 'app/ShelvesRibbon/ALL_SIDES_SELECTION',
  DOORS_SELECTION = 'app/ShelvesRibbon/DOORS_SELECTION',
  TOGGLE_DOOR_SELECTION = 'app/ShelvesRibbon/TOGGLE_DOOR_SELECTION',
  PANES_SELECTION = 'app/ShelvesRibbon/PANES_SELECTION',
  TOGGLE_PANE_SELECTION = 'app/ShelvesRibbon/TOGGLE_PANE_SELECTION',
  PLATE_SELECTION = 'app/ShelvesRibbon/PLATE_SELECTION',

  DELETE_SELECTION = 'app/ShelvesRibbon/DELETE_SELECTION',
}

export const marksHeight = [
  {
    value: 0,
  },
  {
    value: 100,
  },
  {
    value: 170, // R
  },
  {
    value: 135,
  },
  {
    value: 200,
  },
  {
    value: 270,
  },
  {
    value: 370,
  },
  {
    value: 470,
  },
  {
    value: 980,
  },
  {
    value: 1190,
  },
  {
    value: 1390,
  },
];

export default ActionTypes;
